<template>
  <v-container>
    <v-layout>
      <v-flex lg12>
        <jti-expansion-panel panelName="Add Template">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-lg>
              <v-textarea
                outline
                v-model="data.template"
                :readonly="readonly"
                label="Template"
                :rules="[rules.required]"
                append-outer-icon="mdi-comment"
              ></v-textarea>
              <v-textarea
                v-model="data.description"
                :readonly="readonly"
                label="Description"
                rows="2"
                row-height="20"
                :rules="[rules.required]"
              ></v-textarea>
              <v-text-field
                v-model="data.status"
                label="Status"
                :readonly="readonly"
                required
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                v-model="data.proejct"
                label="Project"
                :readonly="readonly"
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-container>
          </v-form>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
    readonly: Boolean,
  },
  computed: {
    computedData() {
      return {
        user_id: this.$store.state.employee.id,
        template: this.data.template,
        description: this.data.description,
        status: this.data.status,
        project: this.data.project,
      };
    },
    test() {
      var string =
        "hallo, this is a test john doe .Another tea house pole. Hey Tom.";
      result = string.match(/(\bt\S+\b)/gi);
      //result = string.match(/(\st\S+)/ig); // alternative
      console.log(result);
    },
  },
  data() {
    return {
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style></style>
